import React, { useState, useEffect } from 'react'
import '../styles/HeaderUser.css'
import logo from '../assets/logo.png'
import carrinhoIcon from '../assets/carrinho-de-compras.png'
import conversasIcon from '../assets/conversas.png'
import configIcon from '../assets/definicoes.png'
import perfilIcon from '../assets/perfil.png'
import historicoIcon from '../assets/historico.png'
import atendentesIcon from '../assets/atendentes.png'
import sairIcon from '../assets/sair.png'
import campanhaIcon from '../assets/disparamos.png'
import disparosIcon from '../assets/campanha.png'
import authcadeado from '../assets/authcadeado.png'
import analytics from '../assets/analytics.png'
import aicon from '../assets/aicon.png'
import campanhaTelefoneIcon from '../assets/celularCampanhaIcon.png'
import arearestrita from '../assets/area-restrita.png'
import privilegeIcon from '../assets/benefit.png'
import config from '../config'
import axios from 'axios'

export default function HeaderUser({ onNavItemClick, userName, onLogout }) {
  const [isExpanded, setIsExpanded] = useState(false)
  const [roboNome, setRoboNome] = useState('')
  const [roboFoto, setRoboFoto] = useState(null)
  const [openGroup, setOpenGroup] = useState(null)
  const handleMouseEnter = () => setIsExpanded(true)
  const handleMouseLeave = () => setIsExpanded(false)
  const toggleGroup = group => setOpenGroup(openGroup === group ? null : group)

  useEffect(() => {
    const fetchRoboData = async () => {
      const token = localStorage.getItem('token')
      try {
        const [nomeResponse, fotoResponse] = await Promise.all([
          axios.get(`${config.apiUrl}/parametros/nomerobo`, { headers: { Authorization: `Bearer ${token}` } }),
          axios.get(`${config.apiUrl}/foto-do-robo`, { headers: { Authorization: `Bearer ${token}` }, responseType: 'blob' })
        ])
        setRoboNome(nomeResponse.data)
        setRoboFoto(URL.createObjectURL(fotoResponse.data))
      } catch { }
    }
    fetchRoboData()
  }, [])

  return (
    <div className={`header-user-container ${isExpanded ? 'expanded' : 'collapsed'}`} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <div className="header-user-content">
        <img src={logo} alt="Logo" className="header-user-logo" />

        <div className="header-user-nav-group">
          <div className="header-user-nav-button" onClick={() => toggleGroup('config')}>
            <img src={configIcon} alt="Configuração" className="nav-icon" />
            <span>Configuração</span>
          </div>
          {openGroup === 'config' && (
            <>
              <div className="header-user-nav-button nav-subitem" onClick={() => onNavItemClick('servicos')}>
                <img src={carrinhoIcon} alt="Serviços" className="nav-icon" />
                <span>Serviços</span>
              </div>
              <div className="header-user-nav-button nav-subitem" onClick={() => onNavItemClick('parametros')}>
                <img src={conversasIcon} alt="Mensagens" className="nav-icon" />
                <span>Mensagens</span>
              </div>
              <div className="header-user-nav-button nav-subitem" onClick={() => onNavItemClick('parametros2')}>
                <img src={configIcon} alt="Parâmetros" className="nav-icon" />
                <span>Parâmetros</span>
              </div>
            </>
          )}
        </div>

        <div className="header-user-nav-group">
          <div className="header-user-nav-button" onClick={() => toggleGroup('campanhas')}>
            <img src={campanhaIcon} alt="Campanhas" className="nav-icon" />
            <span>Campanhas</span>
          </div>
          {openGroup === 'campanhas' && (
            <>
              <div className="header-user-nav-button nav-subitem" onClick={() => onNavItemClick('campanhas')}>
                <img src={campanhaIcon} alt="Listar" className="nav-icon" />
                <span>Campanhas</span>
              </div>
              <div className="header-user-nav-button nav-subitem" onClick={() => onNavItemClick('disparos')}>
                <img src={disparosIcon} alt="Disparos" className="nav-icon" />
                <span>Disparos</span>
              </div>
              <div className="header-user-nav-button nav-subitem" onClick={() => onNavItemClick('cadastroTelefones')}>
                <img src={campanhaTelefoneIcon} alt="Cadastro Telefones" className="nav-icon" />
                <span>Cadastro Telefones</span>
              </div>
            </>
          )}
        </div>

        <div className="header-user-nav-group">
          <div className="header-user-nav-button" onClick={() => toggleGroup('acesso')}>
            <img src={authcadeado} alt="Acesso" className="nav-icon" />
            <span>Acesso</span>
          </div>
          {openGroup === 'acesso' && (
            <>
              <div className="header-user-nav-button nav-subitem" onClick={() => onNavItemClick('autenticacao')}>
                <img src={arearestrita} alt="Autenticação" className="nav-icon" />
                <span>Autenticação</span>
              </div>
              <div className="header-user-nav-button nav-subitem" onClick={() => onNavItemClick('acesso-restrito')}>
                <img src={authcadeado} alt="Acesso Restrito" className="nav-icon" />
                <span>Acesso Restrito</span>
              </div>
              <div className="header-user-nav-button nav-subitem" onClick={() => onNavItemClick('acesso-privilegiado')}>
                <img src={privilegeIcon} alt="Acesso Privilegiado" className="nav-icon" />
                <span>Acesso Privilegiado</span>
              </div>
            </>
          )}
        </div>
        <div className="header-user-nav-button" onClick={() => onNavItemClick('historico')}>
          <img src={historicoIcon} alt="Histórico" className="nav-icon" />
          <span>Histórico</span>
        </div>
        <div className="header-user-nav-button" onClick={() => onNavItemClick('agileone')}>
          <img src={aicon} alt="Agile One" className="nav-icon" />
          <span>Agile One</span>
        </div>
        <div className="header-user-nav-button" onClick={() => onNavItemClick('atendentes')}>
          <img src={atendentesIcon} alt="Atendentes" className="nav-icon" />
          <span>Atendentes</span>
        </div>
        <div className="header-user-nav-button" onClick={() => onNavItemClick('feedback')}>
          <img src={analytics} alt="Feedbacks" className="nav-icon" />
          <span>Feedbacks</span>
        </div>
        <div className="header-user-nav-button" onClick={() => onNavItemClick('conta')}>
          <img src={perfilIcon} alt="Perfil" className="nav-icon" />
          <span>Conta</span>
        </div>
        <div className="header-user-nav-button" onClick={onLogout}>
          <img src={sairIcon} alt="Sair" className="nav-icon" />
          <span>Sair</span>
        </div>
      </div>

      <div className="header-user-footer">
        <span className="footer-robo-nome">{roboNome}</span>
        {roboFoto && <img src={roboFoto} alt="Robo" className="footer-robo-foto" />}
        <span className="footer-username">{userName}</span>
        <span className="footer-title">Área do Cliente</span>
      </div>
    </div>
  )
}
